import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {DistrictRow} from "../types/DistrictRow";
import {trackPricesCityButtonClick} from "./track_prices_city_button_click";

/** A district row opens the district page from several controls (desktop hover overlay, mobile card) - all of them report the same click. */
export const trackPricesCityDistrictRowClick = (district: DistrictRow, href: string) => {
    scheduleTrackingTask(() =>
        trackPricesCityButtonClick({
            buttonName: "rp_apartment_prices_place",
            value: district.name,
            buttonLink: href,
            location: "rp_apartment_prices_city"
        })
    );
};
import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {DistrictRow} from "../types/DistrictRow";
import {trackPricesCityButtonClick} from "./track_prices_city_button_click";

/** A district row opens the district page from several controls (desktop hover overlay, mobile card) - all of them report the same click. */
export const trackPricesCityDistrictRowClick = (district: DistrictRow, href: string) => {
    scheduleTrackingTask(() =>
        trackPricesCityButtonClick({
            buttonName: "rp_apartment_prices_place",
            value: district.name,
            buttonLink: href,
            location: "rp_apartment_prices_city"
        })
    );
};
